import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './Routes';
import SmartLook from 'smartlook-client';

class App extends React.Component {
    componentDidMount() {
        // Debug: Log environment variables to verify they're loaded
        console.log('Environment variables check:', {
            REACT_APP_API_URL: process.env.REACT_APP_API_URL,
            REACT_APP_SIMULATE_SIDE_EFFECTS: process.env.REACT_APP_SIMULATE_SIDE_EFFECTS,
            REACT_APP_SMARTLOOK_ID: process.env.REACT_APP_SMARTLOOK_ID,
            allEnvKeys: Object.keys(process.env || {}).filter(key => key.startsWith('REACT_APP_'))
        });
        
        const urlParams = new URLSearchParams(window.location.search);
        const isPrintMode = urlParams.getAll('printMode').length > 0;
        if (process.env.REACT_APP_SMARTLOOK_ID && !isPrintMode) SmartLook.init(process.env.REACT_APP_SMARTLOOK_ID);
    }
    render() {
        return (
            <>
                <Router>
                    <Routes />
                </Router>
            </>
        );
    }
}

export default App;
